import React from 'react';
import PropTypes from 'prop-types';

const Notification = ({ children }) => {
  return (
    <div className="notification-slideritem">
      <div className="notification">
        <div className="notification-content">
          <p dangerouslySetInnerHTML={{ __html: children }} />
        </div>
      </div>
    </div>
  );
};

Notification.propTypes = {
  children: PropTypes.node
};

export default Notification;
